import { Injectable } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "./appConfig.service";
export class LoggerService {
    constructor(appConfigService) {
        this.appConfigService = appConfigService;
    }
    logInfo(message, object) {
        if (this.appConfigService.configuration.enableLogging) {
            if (!!object) {
                // tslint:disable-next-line:no-console
                console.log(message, object);
            }
            else {
                // tslint:disable-next-line:no-console
                console.log(message);
            }
        }
    }
    logError(message, object) {
        if (this.appConfigService.configuration.enableLogging) {
            if (!!object) {
                // tslint:disable-next-line:no-console
                console.error(message, object);
            }
            else {
                // tslint:disable-next-line:no-console
                console.error(message);
            }
        }
    }
    logWarning(message, object) {
        if (this.appConfigService.configuration.enableLogging) {
            if (!!object) {
                // tslint:disable-next-line:no-console
                console.warn(message, object);
            }
            else {
                // tslint:disable-next-line:no-console
                console.warn(message);
            }
        }
    }
}
LoggerService.ɵfac = function LoggerService_Factory(t) { return new (t || LoggerService)(i0.ɵɵinject(i1.AppConfigService)); };
LoggerService.ɵprov = i0.ɵɵdefineInjectable({ token: LoggerService, factory: LoggerService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(LoggerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.AppConfigService }]; }, null); })();
//# sourceMappingURL=logger.service.js.map